import { NgModule } from '@angular/core';
import { LocalizedDatePipe } from './localized-date.pipe';


@NgModule({
  declarations: [
    LocalizedDatePipe
  ],
  imports: [],
  exports: [
    LocalizedDatePipe
  ],
  providers: [
    LocalizedDatePipe
  ]
})
export class LocalizedDatePipeModule {
}
